import { render, staticRenderFns } from "./RegisterPartner.vue?vue&type=template&id=396e324d&scoped=true&"
import script from "./RegisterPartner.vue?vue&type=script&lang=js&"
export * from "./RegisterPartner.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPartner.vue?vue&type=style&index=0&id=396e324d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396e324d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('396e324d')) {
      api.createRecord('396e324d', component.options)
    } else {
      api.reload('396e324d', component.options)
    }
    module.hot.accept("./RegisterPartner.vue?vue&type=template&id=396e324d&scoped=true&", function () {
      api.rerender('396e324d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/RegisterPartner.vue"
export default component.exports